import { render, staticRenderFns } from "./SportingDirectorDashboard.vue?vue&type=template&id=7b846f9e"
import script from "./SportingDirectorDashboard.vue?vue&type=script&lang=js"
export * from "./SportingDirectorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports